
// 存储资源列表数据
export default {
  namespaced: true,
  state: {
    items: JSON.parse(localStorage.getItem('labelArr') || 'null') || [],
  },
  mutations: {
    CHANEG_ITEM(state, item) {
      state.items = Array.isArray(item) ? item : []
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    },
    ADD_ITEM(state, item) {
      if (!item) return
      const index = state.items.findIndex((i) => i.id == item.id)
      if (index !== -1) {
        state.items.splice(index, 1, { ...item })
      } else {
        state.items.push({ ...item })
      }
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    },
    DELETE_ITEM(state, id) {
      state.items = state.items.filter((item) => item.id != id)
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    },
    UPDATE_ITEM(state, updatedItem) {
      if (!updatedItem) return
      const index = state.items.findIndex((item) => item.id == updatedItem.id)
      if (index !== -1) {
        state.items.splice(
          index,
          1,
          Object.assign({}, state.items[index], updatedItem),
        )
      } else {
        state.items.push({ ...updatedItem })
      }
      localStorage.setItem('labelArr', JSON.stringify(state.items))
    },
  },
  actions: {
    changeItem({ commit }, item) {
      commit('CHANEG_ITEM', item)
    },
    addItem({ commit }, item) {
      // 使用服务端返回的真实数据（含 id），不再本地伪造 id
      commit('ADD_ITEM', item)
    },
    deleteItem({ commit }, id) {
      commit('DELETE_ITEM', id)
    },
    updateItem({ commit }, updatedItem) {
      commit('UPDATE_ITEM', updatedItem)
    },
  },
}
